import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_ROUTES as SETTINGS } from "@/Generated/Routes/paths";

const help: RouteRecordRaw[] = [
  {
    ...SETTINGS.help.root,
    component: () => import("@/Views/settings/help/index.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "settings.help-title",
    },
  },
  {
    ...SETTINGS.help.view.root,
    component: () => import("@/Views/settings/help/View.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "settings.help-title",
    },
  },
];

export default help;
